import React from "react";
import {
  PERIOD_TYPES,
  PERIOD_TYPE_LABELS,
  getPeriodLabel,
  formatPeriodRange,
} from "./periodUtils";

function PeriodSelector({
  periodType,
  anchorDate,
  dateFrom,
  dateTo,
  onPeriodTypeChange,
  onPrev,
  onNext,
  canGoForward = true,
}) {
  return (
    <div className="hr-dashboard__period">
      <div className="hr-dashboard__period-buttons">
        {Object.values(PERIOD_TYPES).map((type) => (
          <button
            key={type}
            type="button"
            className={`hr-dashboard__period-button ${
              periodType === type ? "hr-dashboard__period-button--active" : ""
            }`}
            onClick={() => onPeriodTypeChange(type)}
          >
            {PERIOD_TYPE_LABELS[type]}
          </button>
        ))}
      </div>

      <div className="hr-dashboard__period-nav">
        <button
          type="button"
          className="hr-dashboard__period-nav-btn"
          onClick={onPrev}
          aria-label="Предыдущий период"
        >
          ←
        </button>
        <div className="hr-dashboard__period-labels">
          <span className="hr-dashboard__period-current">
            {getPeriodLabel(periodType, anchorDate)}
          </span>
          <span className="hr-dashboard__period-range">
            {formatPeriodRange(dateFrom, dateTo)}
          </span>
        </div>
        <button
          type="button"
          className="hr-dashboard__period-nav-btn"
          onClick={onNext}
          disabled={!canGoForward}
          aria-label="Следующий период"
        >
          →
        </button>
      </div>
    </div>
  );
}

export default PeriodSelector;
